var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline"},_vm._l((_vm.items),function(item){return _c('button',{key:item.value,class:['btn', {'active': item.value == _vm.value}],attrs:{"id":`switchButton${item.value}`},on:{"click":() => _vm.onClick(item.value)}},[_c('font-awesome-icon',{attrs:{"icon":item.icon}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }